import script from "./TranscriptionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TranscriptionPanel.vue?vue&type=script&setup=true&lang=js"

import "./TranscriptionPanel.vue?vue&type=style&index=0&id=6ddc0dcb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ddc0dcb"]])

export default __exports__